<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Payment Permissions</v-card-title>

        <v-card-text>
            <v-select
                label="Payment Permissions"
                :items="possible_values"
                v-model="value"
                return-object
            />
            
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            employee_profile: null,
            value: null,
            possible_values: [
                { 'text' : 'Request and Process All Payments', 'value' : 'request-and-process' },
                { 'text' : 'Request and Process Your Own Payments', 'value' : 'request-and-self-process' },
                { 'text' : 'Request Only', 'value' : 'request-only' },
                { 'text' : 'No Access', 'value' : 'no-access' },
            ]
        }
    },

    methods: {

        showDialog(employee_profile)
        {
            this.employee_profile = employee_profile;
            
            for ( let i = 0; i < this.possible_values.length; i++ )
            {
                if ( this.possible_values[i].value == employee_profile.payment_permissions )
                {
                    this.value = this.possible_values[i];
                }
            }

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            this.$emit('patch-employee',{
                'employee_id' : this.employee_profile.employee_id,
                'payment_permissions' : this.value.value,
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>